import { useEffect, useState } from "react";
import { api } from "../lib/api";

const OIDC_FLAG = "professionals_oidc_attempt";

export function LoginPage() {
  // Tri-state: null = still checking; true = OIDC is configured (we're about
  // to redirect); false = local fallback. We never render the local form
  // while still checking, to avoid flashing it before the OIDC bounce.
  const [oidcEnabled, setOidcEnabled] = useState<boolean | null>(() => {
    return sessionStorage.getItem(OIDC_FLAG) ? false : null;
  });
  const [error] = useState<string | null>(() => {
    if (sessionStorage.getItem(OIDC_FLAG)) {
      sessionStorage.removeItem(OIDC_FLAG);
      return "Single sign-on did not complete. Try again — or your iambarn admin may need to approve the client.";
    }
    return null;
  });

  useEffect(() => {
    if (error) return;
    let cancelled = false;
    (async () => {
      try {
        const cfg = await api.runtimeConfig();
        if (cancelled) return;
        if (!cfg.oidc?.enabled) {
          setOidcEnabled(false);
          return;
        }
        sessionStorage.setItem(OIDC_FLAG, "1");
        try {
          const { url } = await api.oidcLoginUrl();
          window.location.assign(url);
        } catch {
          window.location.assign(cfg.oidc.login_url || "/api/v1/auth/oidc/login");
        }
      } catch {
        if (!cancelled) setOidcEnabled(false);
      }
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (oidcEnabled === null) {
    return <div className="auth-page" aria-busy="true" />;
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Sign in</h1>
        {error && <div className="alert alert-error" role="alert">{error}</div>}
        <p style={{ color: "var(--muted)", marginTop: "0.5rem" }}>
          Professionals uses single sign-on via iambarn.
          Click below to try again, or contact your operator if the issue persists.
        </p>
        <div style={{ marginTop: "1.5rem", display: "flex", gap: "0.5rem" }}>
          <a href="/" className="btn-ghost" style={{ textDecoration: "none", padding: "0.625rem 1rem", borderRadius: 8, border: "1px solid var(--border)" }}>
            Back to home
          </a>
          <button className="btn-primary" onClick={() => { sessionStorage.removeItem(OIDC_FLAG); window.location.reload(); }}>
            Try sign-in again
          </button>
        </div>
      </div>
    </div>
  );
}
